// 已出分未评价回调状态
export enum EnumCallbackStatus {
  EnumCallbackStatusDefault, // 默认值
  EnumCallbackStatusWait, // 待触发(执行中)
  EnumCallbackStatusSuccess, // 执行成功
  EnumCallbackStatusError, // 执行失败
  EnumCallbackStatusWaitResult = 254, // 发起成功等待回调
  EnumCallbackStatusNoNeed = 255 // 无需触发
}

// 提交状态
export enum EnumSubmitStatus {
  EnumSubmitStatusNotSignIn, // 定向邀请 未登记
  EnumSubmitStatusAnswering, // 答题中
  EnumSubmitStatusFinish, // 已交卷
  EnumSubmitStatusSignIn, // 公开链接 已登记
  EnumSubmitStatusNoScore // 已交卷未评分 临时中间状态
}

// 通知状态
export enum EnumMessageStatus {
  EnumMessageStatusOpenLink, // 公开链接
  EnumMessageStatusNoSend, // 定向邀请 未通知
  EnumMessageStatusNoReply, // 定向邀请 已通知未打开
  EnumMessageStatusApply // 定向邀请 已通知已经打开
}

// 付款状态
export enum EnumCostStatus {
  EnumCostStatusNormal, // 未付款
  EnumCostStatusFinish = 2 // 已付款
}

//候选人加入状态
export enum EnumCandidateJoinStatus {
  EnumCandidateJoinStatusDefault, // 默认值
  EnumCandidateJoinStatusOk, // 未答题
  EnumCandidateJoinStatusAnswering, // 答题中
  EnumCandidateJoinStatusNext, // 答题结束可以重复答题
  EnumCandidateJoinStatusFinish = 101, // 答题结束不可答题
  EnumCandidateJoinStatusExamEarly, // 面试未开始
  EnumCandidateJoinStatusExamEnd, // 面试已结束
  EnumCandidateJoinStatusError = 255 // 未知状态
}

//外链关系状态
export enum EnumOutLinkStatus {
  EnumOutLinkStatusNormal,
  EnumOutLinkStatusLink, // 存在关联
  EnumOutLinkStatusIgnoreCheck // 关联历史数据时应该被忽略
}

//ai执行状态
export enum EnumProcessStatus {
  EnumProcessStatusNormal = 1, // 未开始
  EnumProcessStatusRunning, // 执行中
  EnumProcessStatusFinish, // 完成
  EnumProcessStatusNoNeed = 255 // 无需执行
}

//ai推荐状态
export enum EnumAiRecommendStatus {
  EnumAiRecommendStatusDefault, // 默认
  EnumAiRecommendStatusNotRecommend = 10, // 不推荐
  EnumAiRecommendStatusNormal = 20, // 一般
  EnumAiRecommendStatusRecommend = 30, // 推荐
  EnumAiRecommendStatusVeryRecommend = 40 // 非常推荐
}

//评估状态-ai
export enum EnumAuditStatus {
  EnumAuditStatusNoAudit, // 待评估
  EnumAuditStatusPass, // 通过
  EnumAuditStatusWait, // 待定
  EnumAuditStatusRefuse // 拒绝
}

// 错误项任务名
export enum EnumErrorInfoTask {
  EnumErrorInfoTaskDefault = "",
  EnumErrorInfoTaskFaceCheck = "faceCheck", // 人脸检测-身份认证失败
  EnumErrorInfoTaskBgCheckIdentity = "bgCheckIdentity", // 背调-手机号实名认证
  EnumErrorInfoTaskBgCheckSocial = "bgCheckSocial", // 背调-社会安全
  EnumErrorInfoTaskBgCheckFinancial = "bgCheckFinancial", // 背调-金融
  EnumErrorInfoTaskBgCheck = "bgCheck", // 背景调查-总-close
  EnumErrorInfoTaskReadCheating = "readCheating", // 念稿检测-close
  EnumErrorInfoTaskColor = "eyeColor", // 色盲检测-旧
  EnumErrorInfoTaskFinger = "finger", // 手指检测
  EnumErrorInfoTaskReplacePerson = "replacePerson", // 换人检测
  EnumErrorInfoTaskFaceDetection = "faceDetection", // 露脸检测
  EnumErrorInfoTaskScreenshot = "screenshot", // TODO 截屏检测 后续转为autoSubmitType识别
  EnumErrorInfoTaskMobileJoinCountCheck = "mobileJoinCount", // TODO 跳出检测 后续转为autoSubmitType识别
  EnumErrorInfoTaskWebJump = "webJump" // web防切屏检测
}

// 错误项任务名
export enum EnumCandidateListSortKey {
  ScoreAll = "score_all", // 总分
  ScoreAi = "score_ai", // AI分
  SubmitTime = "submit_time", // 提交时间
  CreatedTime = "created_time", // 创建时间
  LastOperationTime = "last_operation_time", // 末次操作时间
  BeginTime = "begin_time" // 开始答题时间
}
